/**
 * Copyright 2022-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Col } from "react-awesome-styled-grid";
import { Box, FlexContainer } from "@nordcloud/gnui";
import { BreadcrumbsBox } from "~/components/BreadcrumbsBox";
import { ROUTES } from "~/routing/routes";
import { Actions } from "../../components/Actions";

type Props = {
  title: string;
  cloudResourceId?: string;
};

export function ResourceDetailsBreadcrumbs({ title, cloudResourceId }: Props) {
  return (
    <Box spacing="spacing02" padding="0.5rem">
      <FlexContainer justifyContent="space-between">
        <BreadcrumbsBox
          title={title}
          customBreadcrumbs={[
            { label: "Home", uri: "/v2" },
            { label: "Resources", uri: ROUTES.resourcesV2.index },
            { label: title, uri: "" },
          ]}
        />
        <Col>
          <Actions
            resourcesDetails={cloudResourceId ? [{ id: cloudResourceId }] : []}
            size="large"
          />
        </Col>
      </FlexContainer>
    </Box>
  );
}
